import React, { useEffect, useState } from "react";
import { FcSurvey, FcCollapse } from "react-icons/fc";
import QRCode from "react-qr-code";
import Translate from "../../../i18n/i18nTranslate";
import classNames from "classnames";


export default function PreviewHeader({ title, description, id, TitleFontScales, TitleDescriptionFontScales, lang, headerBackgroundPath, totalCount }) {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    console.log("totalCount", totalCount);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Temizleme
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  let QRlanguage = "tr"
  if (lang != undefined) {
    QRlanguage = lang
  }
  return (
    <div className="w-full font-[roboto] flex rounded-lg">
      <div className="w-full flex flex-col text-center items-center justify-center">
        <div
          className="relative z-0 mb-6 w-full group bg-gradient-to-r from-cyan-500 to-blue-500 flex flex-col justify-center items-center text-center py-4 border-b-2"
          style={{
            ...(headerBackgroundPath ? {
              backgroundImage: `url(${headerBackgroundPath})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            } : {}),
            position: 'fixed',
            top: 0,
            zIndex: 5,
            ...(windowWidth <= 800 ? {
              height: '180px'
            } : {
              height: '160px'
            })
          }}
        >
          <div className="hidden absolute ar_v:top-3 top-3 ar_v:left-3 left-20 md:inline z-100">
            <div className="p-2 bg-white border-2 flex flex-col items-center ">
              <div
                className={classNames(
                  "text-[14px] font-extrabold text-center",
                  {
                    "text-[16px] font-extrabold top-0 left-10": windowWidth <= 800,
                  }
                )}
              >
                {Translate("Anketi Paylaşmak İçin", "Components.Preview.PreviewHeader.Share")}
              </div>

              <QRCode
                size={windowWidth <= 800 ? 100 : 70}
                className="m-1 sm:size-[90px]"
                value={process.env.REACT_APP_FRONT_URL + "/survey/" + id + "/" + QRlanguage}
              />
              <div className="text-[16px] sm:text-[18px] font-extrabold text-center">
                {Translate("QR TARATINIZ", "Components.Preview.PreviewHeader.QR_Scan")}
              </div>
            </div>
          </div>
          {!headerBackgroundPath ? <div
            className="ar_v:mt-10 md:mt-24 md:m-7 w-full text-center items-center justify-center flex ar_v:pl-[170px] ar_v:pr-[170px] md:pl-[240px] md:pr-[240px]"
            style={{ position: 'relative', zIndex: 10 }}
          >
            <p
              className={`break-normal leading-relaxed mt-4 md:w-[1200px] m-4 mb-[50px] text-center overflow-hidden text-ellipsis font-[roboto] font-bold text-white ${TitleFontScales}`}
              style={{
                ...headerBackgroundPath ? {
                  position: 'relative',
                  zIndex: 2,
                  textShadow: '0 4px 6px rgba(0, 0, 0, 0.4)',
                } : {}
              }}
            >

              {title}
            </p>
          </div> : ""}


        </div>
        {/* TODO */}
        {/* Description */}
        <div
          className={`relative z-0 w-full group flex justify-center items-center  text-left  px-4 ${windowWidth <= 800 && totalCount < 2 ? "mt-20" : ""
            }`}
        >
          <div
            className="lg:mx-96 mx-4 font-bold break-words w-full"
            style={{
              fontSize:
                windowWidth <= 800
                  ? 20
                  : windowWidth <= 1280
                    ? 28
                    : 35,
              marginBottom:
                totalCount < 2
                  ? windowWidth <= 800
                    ? "-80px"
                    : windowWidth <= 1280
                      ? "-60px"
                      : "-40px"
                  : "0px",
            }}
          >
            {description}
          </div>
        </div>
      </div>
    </div>



  );
}
